import { useEffect, useState } from 'react';

// Detecta se o app está rodando como PWA instalado ("Adicionar à tela de
// início"/"Instalar app"), em vez de aberto normalmente no navegador.
// `display-mode: standalone` é o padrão (Android/Chrome/Desktop); o iOS
// Safari não implementa esse media query e expõe `navigator.standalone` em
// vez disso - por isso checamos os dois.
function detectStandalone() {
    if (typeof window === 'undefined') return false;

    const isDisplayModeStandalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
    const isIosStandalone = window.navigator && window.navigator.standalone === true;

    return Boolean(isDisplayModeStandalone || isIosStandalone);
}

const useIsStandalone = () => {
    const [isStandalone, setIsStandalone] = useState(detectStandalone);

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;

        const mql = window.matchMedia('(display-mode: standalone)');
        const handleChange = () => setIsStandalone(detectStandalone());

        if (mql.addEventListener) {
            mql.addEventListener('change', handleChange);
            return () => mql.removeEventListener('change', handleChange);
        }

        // Safari mais antigo só tem a API legada (addListener/removeListener).
        mql.addListener(handleChange);
        return () => mql.removeListener(handleChange);
    }, []);

    return isStandalone;
};

export default useIsStandalone;
